import React from 'react'
import { Accordion, Card } from 'react-bootstrap'

const About = () => {
    return (
        <div id="About" className="text-center bg-light p-5">
            <div className="mb-2">
                <h1 style={{ color: "#98426a" }}>
                    Why This Book?
           </h1>
                <p className="lead">
                    <b className="text-dark text-center">"MR.MACK" </b> uses new educational techniques that makes it easier to master the
              English language in no time!
              </p>
                <hr style={{ width: "30%", margin: "0 auto" }}></hr> 
                </div>

            <Accordion defaultActiveKey="0" className="mt-5">
                <Card className="text-center">
                    <Accordion.Toggle as={Card.Header} eventKey="0" >
                        <i className="fas fa-arrow-circle-down"></i> Mind-map technique
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey="0">
                        <Card.Body>
                            The author in <b className="text-dark">"MR.MACK" </b>
                   explains all the lessons using 'Mind-maps' to make it easier for the kid to memorize the new vocabulary.
                </Card.Body>
                    </Accordion.Collapse>
                </Card>
                
                <Card className="text-center">
                    <Accordion.Toggle as={Card.Header} eventKey="1">
                        <i className="fas fa-arrow-circle-down"></i> Teaching grammar through stories
                        </Accordion.Toggle>
                    <Accordion.Collapse eventKey="1">
                        <Card.Body>
                            The author in <b className="text-dark">"MR.MACK" </b>
                   explains all grammar lessons using stories to help the kid easily understand and write right structure.
                  </Card.Body>
                    </Accordion.Collapse>
                </Card>

                <Card className="text-center">
                    <Accordion.Toggle as={Card.Header} eventKey="2">
                        <i className="fas fa-arrow-circle-down"></i>  'C.D' for better listening skills
                   </Accordion.Toggle>
                    <Accordion.Collapse eventKey="2">
                        <Card.Body>
                            <b className="text-dark">"MR.MACK" </b>
                   provides a 'C.D' with audio and video explaination. Besides, a variety of exercises.
                  </Card.Body>
                    </Accordion.Collapse>
                </Card>
            </Accordion>
        </div>
    )
}

export default About
